import { postObject } from "../ChoiceApi";

export async function search(payload: IServiceLocationSearchInputs): Promise<Array<IServiceLocationSearchItem>|undefined> {
    return (await postObject<Array<IServiceLocationSearchItem>>("api/ServiceLocation/Search", payload));
}

export interface IServiceLocationSearchInputs {
    searchText?: string,
    displayAllResults: boolean,
    limitToClaimLocations?: boolean
}

export interface IServiceLocationSearchItem {
    entity_id?: number;
    service_location_name?: string;
    address1?: string;
    city?: string;
    state?: string;
    zip_code?: string;
    primary_phone_number?: string;
    is_billable?: boolean;
    service_location_id?: number;
}
